import { recordRUMEvent, RUM_EVENTS_ENUM } from '../../services/rum/rum.service';
import { terminateSisenseSession } from '../../../shared/services/sisense/sisense.service';
import { triggerPartnerLogout } from '../../../shared/services/partner-logout/partner-logout.service';
import { handleLogout as handleAuthLogout } from '../utils/auth-utils';

/**
 * Best-effort partner session termination, then Sisense (if embedded), then Auth0/Keycloak logout.
 */
export const performLogout = async ({ keycloak, auth0, global, logoutType = 'manual-logout' }) => {
  sessionStorage.clear();
  sessionStorage.setItem('isLogoutInitiated', true);

  try {
    await triggerPartnerLogout();
  } catch (error) {
    console.error('Partner logout failed during admin logout', error);
  }

  if (global?.sisenseInitialize) {
    terminateSisenseSession();
  }

  recordRUMEvent(RUM_EVENTS_ENUM.LOGOUT_INITIATED, { type: logoutType });
  handleAuthLogout(keycloak, auth0);
};
